import React, { useState, useEffect } from 'react'
import axios from 'axios'
import jwt_decode from 'jwt-decode'
import Dasnav from '../components/Dasnav'
import Footer from '../components/Footer'

export default function ManageUser() {
  var token = localStorage.getItem('token')
  if (token) {
    var decoded = jwt_decode(token)
    // console.log(decoded)
  }
  if (decoded.user.email !== process.env.REACT_APP_ADMIN) {
    window.location.pathname = '/dashboard'
  }

  const [User, setUser] = useState([])

  useEffect(() => {
    axios
      .get('/admin/user', {
        headers: { token },
      })
      .then(res => setUser(res.data))
      .catch(err => console.log(err))
  }, [token])
  console.log(User)

  return (
    <div>
      <Dasnav />
      <table>
        <tr>
          <th>Id</th>
          <th>Email</th>
          <th>Name</th>
        </tr>
        {User.map(item => {
          return (
            <tr key={item._id}>
              <td>{item._id}</td>
              <td>{item.email}</td>
              <td>{item.name}</td>
            </tr>
          )
        })}
      </table>
      <Footer />
    </div>
  )
}
